import Modal from '@src/common/Modal';
import React, { useState } from 'react';
import { RaiseClaim } from '@src/store/slices/insurance';
import { useDispatch } from 'react-redux'
import FullPageLoader from '@src/common/FullPageLoader';
import { toast } from 'react-toastify';
import { CLAIM_TYPE_CREATED_SOURCE, STATUS_CODES } from '@src/config/constant';

interface ClaimTypePopupProps {
    show: boolean;
    handleClose: () => void;
    claimTypes: { value: number; label: string }[];
    leadId: number | null;
    leadDetail:any;
    onSuccess: (response: { leadHashId: string; popUpText: string, payment_done: boolean;}) => void;
}


function ClaimTypePopup({ show, handleClose,claimTypes,leadId,leadDetail,onSuccess }: ClaimTypePopupProps) {
    const [selectedOption, setSelectedOption] = useState<number>();
    const [isThirdPart, setIsThirdPart] = useState(false);

    const [thirdPartyData, setThirdPartyData] = useState({
        third_party_name: '',
        third_party_mobile: '',
        });

    const [errField, setErrField] = useState<any>({
        third_party_name : "",
        third_party_mobile: "",
        claim_type: "",
    });

    const dispatch: any = useDispatch();

    const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedValue = +event.target.value;
        const selectedOption = leadDetail?.raise_claim?.find(
            (claim: any) => claim.value === selectedValue
        );
        if (selectedOption && selectedOption.is_raised) {
            toast.error(selectedOption.error || 'This claim type is already raised.');
            return;
        }
        setSelectedOption(+event.target.value);
        if(+event.target.value === 3){
        setIsThirdPart(true);
        }else{
        setIsThirdPart(false);
        }
    };

    const handleInputChage = (key:string, value:any) => {
        setErrField((prevState: any) => ({
            ...prevState,
            [key]: "",
        }));
        setThirdPartyData((prevState) => ({
            ...prevState,
            [key]: value,
            }));
    }
    const [loading, setLoading] = useState<boolean>(false);

    const validForm = () => {
        let formIsValid = true;
        setErrField({
            third_party_name : "",
            third_party_mobile: "",
            claim_type: "",
        });

        if(selectedOption === 3){
            if (thirdPartyData.third_party_name === "") {

                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    third_party_name: "Third Party Name is required",
                }));
            }
            if (thirdPartyData.third_party_mobile === "" || thirdPartyData.third_party_mobile.trim() === "") {

                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    third_party_mobile: "Third Party Mobile is required",
                }));
            }else if (!/^[9]\d{9}$/.test(thirdPartyData.third_party_mobile)) {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    third_party_mobile: "Mobile No. must be 10 digits and start with 9",
                }));
            }
        }else{
            if(!selectedOption){
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    claim_type: "Please select any claim type",
                }));
            }
        }

        return formIsValid;
    };

    const restrictInvalidKeys = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const invalidKeys = ["e", "E", "+", "-", "."];
        if (invalidKeys.includes(event.key)) {
            event.preventDefault();
        }
    };

    const handleSubmit = () => {
        setLoading(true)
        if(validForm()){
            let requestData:any = {
                lead_id: leadId,
                claim_type : selectedOption,
                source: CLAIM_TYPE_CREATED_SOURCE.agentWeb
            }
            if(selectedOption === 3){
                requestData = {
                    ...requestData,
                    third_party_name : thirdPartyData.third_party_name,
                    third_party_mobile : thirdPartyData.third_party_mobile
                }
            }
            dispatch(RaiseClaim(requestData)).then((res: any) => {
                setLoading(false)
                if (res && res.status === STATUS_CODES['success']) {
                    onSuccess({
                        leadHashId: res.data.lead_hash_id,
                        popUpText : res.message || res?.data?.message,
                        payment_done : res.data.payment_done
                      });
                }
            }).catch((err: Error) => {
                setLoading(false)
            })
        }else{
            setLoading(false);
        }
    }
    
    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="model-outer upload-error-popup">
            <Modal show={show} handleClose={handleClose}>
                <div className="modal-body">
                    
                    <h2>Insurance Claim Type</h2>
            
                        <div className="radio-btn d-block w-100">
                            {claimTypes.map((claim) => (
                                <fieldset key={claim.value} className="from-group radio-type-txt">
                                <div className="custom-control custom-checkbox">
                                    <input
                                    id={`claim-type-${claim.value}`}
                                    type="radio"
                                    className="custom-control-input"
                                    name="claim_type"
                                    value={claim.value.toString()}
                                    checked={selectedOption === +claim.value.toString()}
                                    onChange={handleOptionChange}
                                    />
                                    <label className="custom-control-label">{claim.label}</label>
                                </div>
                                </fieldset>
                            ))}
                            {errField.claim_type && (
                                <span className="error-txt">
                                    {errField['claim_type'] || ""}
                                </span>
                            )}
                        </div>
                        {
                            isThirdPart && 
                            <>
                                <fieldset>
                                    <div className={"material " + (errField.third_party_name ? "error" : "")} >
                                        <input
                                            type="text"
                                            placeholder=" "
                                            name="Third Party Name"
                                            value={thirdPartyData.third_party_name}
                                            className="form-input"
                                            onChange={(e) => handleInputChage('third_party_name',e.target.value)}
                                        />
                                        <label data-label="Third Party Name" className="form-label"></label>
                                        {errField.third_party_name && (
                                            <span className="error-txt">
                                                {errField['third_party_name'] || ""}
                                            </span>
                                        )}
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <div className={"material " + (errField.third_party_mobile ? "error" : "")} >
                                        <input
                                            type="number"
                                            placeholder=" "
                                            name="Third Party Mo. No."
                                            value={thirdPartyData.third_party_mobile}
                                            className="form-input"
                                            onChange={(e) => handleInputChage('third_party_mobile',e.target.value)}
                                            onKeyDown={restrictInvalidKeys}
                                        />
                                        <label data-label="Third Party Mo. No." className="form-label"></label>
                                        {errField.third_party_mobile && (
                                            <span className="error-txt mt-2">
                                                {errField['third_party_mobile'] || ""}
                                            </span>
                                        )}
                                    </div>
                                </fieldset>
                            </>  
                            
                        }
                    
                </div>
                
                <div className=''>
                    <button className='btn-primary btn-width-100' onClick={handleSubmit}>Submit</button>
                </div>
            </Modal>
            </div>
        </React.Fragment>
    );
}


export default ClaimTypePopup;